var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-1720 -346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9749",
    "data-name": "Path 9749",
    d: "M14.5,0a14.5,14.5,0,0,1,7.261,27.054A14.162,14.162,0,0,1,14.5,29a14.5,14.5,0,0,1,0-29Z",
    transform: "translate(1720 346)",
    fill: "#a4a2dc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_352285_content_copy_icon",
    "data-name": "352285_content_copy_icon",
    transform: "translate(1726.567 352.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9747",
    "data-name": "Path 9747",
    d: "M0,0H15.7V15.7H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748",
    "data-name": "Path 9748",
    d: "M13.158,2H5.308A1.308,1.308,0,0,0,4,3.308v9.158H5.308V3.308h7.85Zm1.963,2.617h-7.2A1.308,1.308,0,0,0,6.617,5.925v9.158a1.308,1.308,0,0,0,1.308,1.308h7.2a1.308,1.308,0,0,0,1.308-1.308V5.925A1.308,1.308,0,0,0,15.121,4.617Zm0,10.467h-7.2V5.925h7.2Z",
    transform: "translate(-2.692 -1.346)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRound);
export default __webpack_public_path__ + "static/media/copy-round.f33af5e9dd4a80977ec2eea1ee8a8954.svg";
export { ForwardRef as ReactComponent };